import React, { useEffect, useState, useRef } from 'react'
import ExcelExport from '../ExcelExport'
import { Link, useNavigate } from 'react-router-dom';
import { optionProductsByProducts, provinces } from '../Options';
import Multiselect from 'multiselect-react-dropdown';
import Sidebar from '../Sidebar';
// import env from 'react-dotenv'

export default function PCGATable() {

    const [prices, setPrices] = useState([])
    const [filteredPrices, setFilteredPrices] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [todayMessage, setTodayMessage] = useState('Show todays values')
    
     //Pagination
    const [page, setPage] = useState(1)
    const [postsPerPage, setPostsPerPage] = useState(20)
    const getPrices = async ()=> {
      const token = sessionStorage.getItem('token')
        const response = await fetch(`${process.env.REACT_APP_API_URL}/getPCGA`,{
          headers: {
            'x-access-token': token
          }
        })
        const pricelist = await response.json()
        pricelist.sort((a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          return dateB - dateA;
        });
        setPrices(pricelist)
       // console.log(prices)
    }

    const totalPages = Math.ceil(prices.length / postsPerPage);
    const pageRange = 10; // Number of page buttons to show at a time

    const startPage = Math.max(1, page - Math.floor(pageRange / 2));
    const endPage = Math.min(totalPages, startPage + pageRange - 1);

    const pageButtons = [...Array(endPage - startPage + 1)].map((_, i) => startPage + i);
    useEffect(()=>{
        getPrices()
    }, [])

    
    const lastPostIndex = page*postsPerPage
    const firstPostIndex = lastPostIndex - postsPerPage
    const currentPrices = prices.slice(firstPostIndex, lastPostIndex)
    const selectPageHandler =(selectedPage)=>{
      setPage(selectedPage)
    }

    
    

    // The Delete Button
    const handleDelete = async (itemId) =>{
      const fL = prices.filter((filteredPrice) => filteredPrice._id !== itemId)
      const token = sessionStorage.getItem('token')
      await fetch(`${process.env.REACT_APP_API_URL}/delete-PCGA/${itemId}`,{
          method:'DELETE',
          headers: {
              'Content-Type':'application/json',
              'x-access-token':token
          }
      })
        // .then(console.log("Delete successfull"))
    setPrices(fL)
  }

  //edit page
  const navigate = useNavigate()
  //Edit page
  const handleEdit = async (itemId) =>{
    navigate(`/update-sowing/${itemId}`)
   // console.log("In the button")
  }



  return (
    <><div className="sidebar">
    <Sidebar/>
    <h2 id='tabler'>PCGA</h2>
    </div>
   
        <div id='tabler1'>

        <div className='tables-option-div'>
      <div className="row">
        <div className="col">
          <div className="tables-options">
          <ExcelExport excelData={prices} fileName={'PricesSheet'} />
          </div>
        </div>

        <div className="col">
        <div className="tables-options">
        <Link to='/inputPCGA'> <button type="button" class="btn btn-success table-buttons">   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-arrow-up-fill" viewBox="0 0 16 16">
  <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6.354 9.854a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 8.707V12.5a.5.5 0 0 1-1 0V8.707L6.354 9.854z"/>
</svg>        Upload excel</button></Link>
        </div>
        </div>
      </div>            
      </div>
          
          {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1>PCGA </h1>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ marginBottom: '10px', padding:"30px 30px 30px 30px"}}>
          <ExcelExport excelData={prices} fileName={'PricesSheet'} />
        </div>
        <div style={{ marginBottom: '10px', padding:"30px 10px 30px 10px"}}>
        <Link to='/inputPCGA'> <button type="button" class="btn btn-success">   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-arrow-up-fill" viewBox="0 0 16 16">
  <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6.354 9.854a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 8.707V12.5a.5.5 0 0 1-1 0V8.707L6.354 9.854z"/>
</svg>        Upload excel</button></Link>
        </div>   
        </div>
        
      </div>   */}

      <table class="table" id="table1">

      <thead>
  <tr>
    
    {/* <th scope="col">Price_id</th> */}
    <th scope='col'>Date</th>
    <th scope="col" >Crop Year</th>
    <th scope="col">District</th>
    <th scope="col">Arrivals (Bales)</th>
    <th scope="col">Pressing (Bales)</th>
    <th scope="col">Exporter</th>
    <th scope="col">Textile</th>
    <th scope="col">Total Sold</th>
    <th scope="col">Unsold Bales</th>
    <th scope="col">Unginned Bales</th>
  </tr>
</thead>

  <tbody>
  
      {currentPrices && currentPrices.map((price, index) =>(
            <tr key={price._id}>
                <td>{new Date(price.date).toLocaleDateString('en-US')}</td>
                <td>{price.cropYear}</td>
                <td>{price.nameOfDistrict}</td>
                <td>{price.arrivalsInBales}</td>
                <td>{price.pressingInBales}</td>
                <td>{price.exporters}</td>
                <td>{price.textiles}</td>
                <td>{price.totalBalesSold}</td>
                <td>{price.stockOfUnsoldBales}</td>
                <td>{price.stockOfUnginnedBales}</td>
                <td><button type="button" class="btn btn-danger" onClick={()=>handleDelete(price._id)}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/> <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/></svg></button></td>
                {/* <td>  <Link type="button" class="btn btn-info" to={`/update-sowing/${price._id}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16"><path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/><path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/></svg></Link></td>
             */}
            </tr>
      ))}
  </tbody>
  
</table>


{currentPrices.length > 0 && (
  <div className="pagination">
    <br />
    {pageButtons.map((pageNumber) => (
      <button
        type="button"
        id="num-but"
        class="btn btn-secondary btn-lg mb-2"
        onClick={() => selectPageHandler(pageNumber)}
        key={pageNumber}
      >
        {pageNumber}
      </button>
    ))}
    <br />
    {/**Fixing the date issue */}
  </div>
)}
{!prices && <div class="alert alert-primary" role="alert">
  Oops! Something went wrong.
</div>}


    </div>
    
    </>
    
  )


  
}
